import React from 'react';
import { FieldRichTextEditorWithReduxProps } from './types';
import { FieldRichTextEditor } from '.';

export const FieldRichTextEditorWithRedux = ({
  meta: { error, submitFailed, valid },
  input,
  rows,
  ...html
}: FieldRichTextEditorWithReduxProps) => (
  <FieldRichTextEditor
    {...html}
    {...input}
    rows={rows}
    isShowingError={submitFailed && !valid}
    error={error ? { message: error } : undefined}
  />
);
